import {
  Divider,
  GKButton,
  Grid2,
  Show,
  Tab,
  Tabs,
  Typography,
} from "components";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { EMPLOYEE_ASSIGN_ROLE, GET_EMPLOYEE_BY_ID } from "utils/apiRoutes";
import axiosInstance from "utils/axiosInstance";
import { QueryKeys } from "utils/queryKey";
import AdminAccess from "./AdminAccess";
import AssignRoleModal from "./AssignRoleModal";
import EmployeesPermissions from "./BranchAdminsPermissions";
import EditAdminModal from "./EditAdminModal";

const AdminDetails = () => {
  const { id } = useParams<string>();

  const { employeeERMTabs } = useAppSelector((state) => state?.app?.tab);
  const dispatch = useAppDispatch();

  const [openEditModal, setOpenEditModal] = useState(false);
  const [assignRoleModal, setAssignRoleModal] = useState(false);

  const { data: employeeDetails, isFetching: isInitialLoading } = useFetchQuery(
    {
      key: [QueryKeys.EMPLOYEE_LIST, id],
      route: GET_EMPLOYEE_BY_ID(id),
    },
  );

  const { mutate: sendRegistrationLink, isLoading: linkLoading } = useMutation({
    mutationFn: (data: any) =>
      axiosInstance.post("/send-admin-reg/", { employee: data }),
    mutationKey: ["SEND_REGISTRATION_LINK"],
  });

  return (
    <DashboardLayout title="Branch Admin" loading={isInitialLoading}>
      <Grid2 container spacing={1}>
        <Grid2 size={6}>
          <Typography
            fontWeight={600}
            fontSize={18}
            textTransform={"capitalize"}
          >
            {employeeDetails?.data?.user?.personalDetails?.name || "-"}:{" "}
            {employeeDetails?.data?.code || "-"}
          </Typography>
          <Typography fontSize={12} textTransform={"capitalize"}>
            {employeeDetails?.data?.role || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={6} textAlign={"right"}>
          <GKButton
            loading={linkLoading}
            onClick={() => {
              sendRegistrationLink(id);
            }}
            variant="outlined"
            color="dark"
          >
            Send Registration Link
          </GKButton>
          &nbsp;
          <GKButton
            variant="outlined"
            color="dark"
            onClick={() => setAssignRoleModal(true)}
          >
            Assign Role
          </GKButton>{" "}
        </Grid2>
        <Grid2 size={12} my={1}>
          <Tabs
            value={employeeERMTabs}
            onChange={(e, val) => {
              dispatch(TAB({ tabKey: "employeeERMTabs", tabValue: val }));
            }}
          >
            <Tab label="Permissions" value={0} />
            <Tab label="Access" value={1} />
          </Tabs>
          <Divider />
        </Grid2>
        <Grid2 size={12}>
          <Show.When isTrue={employeeERMTabs === 0}>
            <EmployeesPermissions />
          </Show.When>
        </Grid2>
        <Grid2 size={12}>
          <Show.When isTrue={employeeERMTabs === 1}>
            <AdminAccess />
          </Show.When>
        </Grid2>
      </Grid2>

      <Show.When isTrue={openEditModal}>
        <EditAdminModal open={openEditModal} setOpen={setOpenEditModal} />
      </Show.When>

      <Show.When isTrue={assignRoleModal}>
        <AssignRoleModal
          open={assignRoleModal}
          setOpen={setAssignRoleModal}
          getAssignRoleApi={{
            key: ["ASSIGN_ROLE_FOR_EMPLOYEE"],
            route: EMPLOYEE_ASSIGN_ROLE(id),
          }}
          roleType="employee"
          refetchQueryName={QueryKeys.EMPLOYEE_PERMISSION}
        />
      </Show.When>
    </DashboardLayout>
  );
};

export default AdminDetails;
